import React from "react";
import { Outlet } from "react-router-dom";
// import Navbar from "../Components/Navbar/Navbar";
// import Footer from "../Components/Footer/Footer";
// import ScrollTop from "../Components/ScrollTop/ScrollTop";
const IndustryLayout = () => {
  return (
    <>
      {/* <Navbar /> */}
      <Outlet />
    </>
  );
};

export default IndustryLayout;
